export default __webpack_public_path__ + "static/media/brand-5.73b0b121.png";